module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/EC-eba2339e20ee28dcc51873d8cad03e34.png";